import Subscriber from '../subscriber.js';
import { DATA_TYPES, DATA_EVENTS } from '../constant';
import { Task } from '../task-manager';
import logger from '../../util/logger';
import guid from '../../util/guid';

export default class MarketsPull extends Subscriber {
    constructor(option) {
        super(option);
        this.id = guid();
        this.type = DATA_TYPES.PULL;
        this.taskManager = option.taskManager;
        this.task = new Task({
            context: this,
            id: `${DATA_TYPES.PULL}`,
            executionInterval: option.frequency,
            execute: this._query
        });
        this.on(DATA_EVENTS.SUBSCRIBE, res => {
            if (res.type === DATA_TYPES.PULL) {
                this.task.addParameters(res.data);
                this.task.updateLastAccessTime = res.updateLastAccessTime;
                this.taskManager.add(this.task);
                this.emit(DATA_EVENTS.AFTER_SUBSCRIBE, res.data);
            }
        }).on(DATA_EVENTS.UNSUBSCRIBE, res => {
            if (res.type === DATA_TYPES.PULL) {
                this.task.deleteParameters(res.data);
                this.emit(DATA_EVENTS.AFTER_UNSUBSCRIBE, res.data);
            }
        });
    }
    async quotes(params) {
        let securities = await this.securityManager.create(
            params.securities,
            params.skipIdService
        );
        securities = securities.filter(
            security => security.quoteInstrument.length > 0
        );
        if (securities.length > 0) {
            const instruments = this.securityManager.getQuoteInstruments(
                securities
            );
            const requestParams = {
                instruments,
                method: params.method,
                timeout: params.timeout
            };
            const quotes = await this.apiManager.quoteMarketsPull(
                requestParams
            );
            return this._generateQuotes(securities, quotes);
        } else {
            throw this.securityManager.getInvalidSecuritiesError(
                params.securities
            );
        }
    }
    statisticsTickers(params) {
        return this.apiManager.quoteMarketsStatisticsTickers(params);
    }
    statistics(params) {
        const quoteFields = params.quoteFields
            ? `:${params.quoteFields.replace(/,/g, '|')}`
            : '';
        const fields = params.statFields.split(',').map(statField => {
            return `${statField}${quoteFields}`;
        });
        const requestParams = {
            tickers: params.instruments.join(','),
            fields: fields.join(','),
            updateLastAccessTime: params.updateLastAccessTime
        };
        return this.apiManager.quoteMarketsStatistics(requestParams);
    }
    async _query(task) {
        const self = task.context;
        const instruments = task.params.slice(
            task.executeIndex,
            task.params.length
        );
        if (instruments.length) {
            const requestParams = {
                instruments,
                updateLastAccessTime: task.updateLastAccessTime
            };
            const quotes = await self.apiManager
                .quoteMarketsPull(requestParams)
                .catch(error => {
                    logger.error(
                        'moringstar.markets.marketdata.marketsPull',
                        'failed to polling from markets pull service',
                        error.config || error.message
                    );
                });
            self.emit(DATA_EVENTS.DATA, {
                type: self.type,
                data: quotes
            });
        }
    }
}
